import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import Nav from "../../components/Nav";
import ImageSection from "./ImageSection";
import MintInfoSection from "./MintInfoSection";
import axios from "axios";
import env from "../../constants/env";
import ProcessingModal from "../../components/ProcessingModal";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useNavigate } from "react-router-dom";
import Web3 from "web3";
import { MOBILE } from "../../constants/breakpoints";
import { SignatureVerificationSection } from "./SignatureVerificationSection";
import Button from "../../components/Button";
import { Row } from "../Assets/style";

//sample data : remove after testing
let nftMetadata = {
  token_address: "0x70a3c6c757e28863f37522386d66105738c88e73",
  token_id: "17",
  amount: "1",
  owner_of: "0xeca51b06793e83dcbffec847c0948d2aee1b60b5",
  token_hash: "1b46917a502e80a83307d283d7291190",
  block_number_minted: "9068945",
  block_number: "9068945",
  transfer_index: [9068945, 7, 11, 0],
  contract_type: "ERC721",
  name: "Proxy Token Test PP Tokens ",
  symbol: "PTTPP",
  token_uri:
    "https://ipfs.moralis.io:2053/ipfs/QmWXJXRdExse2YHRY21Wvh4pjRxNRQcWVhcKw4DLVnqGqs/17",
  metadata:
    '{"attributes":[{"trait_type":"Background","value":"Purple"},{"trait_type":"Skin","value":"Normal"},{"trait_type":"Body","value":"Lei Pink"},{"trait_type":"Face","value":"Clout Goggles"},{"trait_type":"Head","value":"Pirate Hat"}],"description":"A collection 8888 Cute Chubby Pudgy Penquins sliding around on the freezing ETH blockchain.","image":"https://ipfs.io/ipfs/QmNf1UsmdGaMbpatQ6toXSkzDpizaGmC9zfunCyoz1enD5/penguin/17.png","name":"Pudgy Penguin #17"}',
  last_token_uri_sync: "2023-05-26T19:05:36.233Z",
  last_metadata_sync: "2023-06-02T14:36:50.143Z",
  minter_address: "0xeca51b06793e83dcbffec847c0948d2aee1b60b5",
  possible_spam: false,
};

function MintDetails() {
  const [nftMetadata, setNftMetadata] = useState<any>({});
  const [nftData, setNftData] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isBurn, setIsBurn] = useState<boolean>(false);
  const [isSignatureVerified, setIsSignatureVerified] = useState<boolean>(false);
  let wallet = useSelector((state: RootState) => state.walletState);
  let navigate = useNavigate();


  useEffect(() => {
    const data = localStorage.getItem('ACTIVE_PROXY_TOKEN_DETAILS') ?? '{}'
    const nftData_ = JSON.parse(data)
    setNftData(nftData_)
    setIsLoading(false);
    setNftMetadata({ metadata: JSON.stringify(nftData_?.parsedMetadata) });
  }, []);

  const handleBurnProxyToken = async () => {
    setIsBurn(true)
  }

  return (
    <>
      {isLoading && (
        <ProcessingModal
          processingMessage="Fetching Proxy Token Metadata"
          loaderHeading="Loading Data..."
        />
      )}
      <div
        css={css`
          display: flex;
          flex-direction: column;
          width: 100%;
          min-height: 100vh;
          background-color: #ffffff;
          background-repeat: no-repeat;
          background-position: top right;
          margin-bottom: 44px;
        `}
      >
        <Nav />
        <section
          css={css`
            display: flex;
            max-width: 1140px;
            margin: 0 auto;
            margin-top: 110px;
            gap: 70px;
            align-items: center;
            @media (max-width: ${MOBILE}px) {
              justify-content: center;
              flex-direction: column;
              margin: 0 15px;
            }
          `}
        >
          <ImageSection nftMetadata={nftMetadata} />
          <span>
            {
              isBurn
                ? <SignatureVerificationSection setIsBurn={setIsBurn} isVerified={isSignatureVerified} assetWallet={wallet.assetAddress ?? ""} selectedProxyTokenInitMint={nftData} />
                : <MintInfoSection nftMetadata={nftMetadata} handleBurnMintedProxyToken={handleBurnProxyToken} />
            }
            {
              isSignatureVerified && isBurn
                ? <Row width="100%" justify="center" padding="20px 0 0">
                  <Button
                    onClick={() => { }}
                    IconHeight='15px'
                    type="YELLOW"
                  >
                    Burn Token
                  </Button>
                </Row>
                : <></>
            }

          </span>
        </section>
      </div>
    </>
  );
}

export default MintDetails;
